export enum UserRole {
  None = 0,
  Ceo = 1,
  ProjectManager = 2,
  Foreman = 3,
  Worker = 4,
  Agent = 5,
  LearningManager = 6,
  HR = 7,
  Stakeholder = 8,
  Admin = 128,
}
